export default __webpack_public_path__ + "static/media/prologue-realcouch.f42e6674.png";